import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';
import moment, { duration } from 'moment';
import { Duration } from 'moment/moment';
import { map } from 'rxjs/operators';
import _ from 'lodash';

@Pipe({
   name: 'durationToText$',
})
export class DurationToTextPipe implements PipeTransform {
   transform(inputValue: Duration | number | Observable<Duration> | Observable<number>): Observable<string> {
      const duration$ = isObservable(inputValue) ? inputValue : of(inputValue);

      return duration$.pipe(
         map((x) => {
            if (!_.isNumber(x)) {
               return x;
            }
            return moment.duration(x, 'ms');
         }),
         map((waitingDuration) => {
            if (waitingDuration.asMilliseconds() < 0) {
               return '';
            }
            const waitingHours = waitingDuration.hours();
            const waitingMinutes = waitingDuration.minutes().toString().padStart(2, '0');
            const waitingSeconds = waitingDuration.seconds().toString().padStart(2, '0');

            if (waitingHours > 0) {
               return `${waitingHours}:${waitingMinutes}:${waitingSeconds}`;
            }
            return `${waitingMinutes}:${waitingSeconds}`;
         })
      );
   }
}
